import React, { useEffect, useState } from 'react';
import { Box, Grid, Modal } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CheckIcon from '@mui/icons-material/Check';
import RoundButton from '../components/roundButton';

export default function CartModal(props) {
  const {
    open,
    imageURL,
    name,
    partNumber,
    quantity,
    price,
    showWarningSign,
    unitOfMeasure,
    totalProductPrice,
    totalItems,
    viewCartUrl,
    checkoutUrl,
    handleClose
  } = props;

  const [viewCartText, setViewCartText] = useState(
    'View Cart(' + totalItems + ')'
  );

  useEffect(() => {
    console.log('props = ' + imageURL);
  });

  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="modal-common cart-modal">
        <Grid container>
          <Grid item xs={12} onClick={handleClose} className="align-right">
            <CloseRoundedIcon />
          </Grid>
          <Grid item xs={12}>
            <h2 className="itemAddedText">
              <CheckIcon /> Item Added to Cart
            </h2>
            <hr />
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={3} className="image-box">
                  <img className="image" src={imageURL} />
                  {showWarningSign && (
                    <a
                      className="prop65-tooltip"
                      data-toggle="tooltip"
                      data-placement="right"
                      data-trigger="hover"
                      title=""
                      data-original-title="WARNING: This product can expose you to chemicals including Lead and Lead Compounds which is known to the State of California to cause cancer and birth defects or other reproductive harm. For more information go to www.P65Warnings.ca.gov"
                    >
                      <img
                        className="prop-65-img warningSign"
                        alt="chemicalComposition"
                        src="https://ph.parker.com/wcsstore/ParkerB2BStorefrontAssetStore/images/chemical-composition-warning.png"
                      />
                    </a>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={9}>
                  <a>{name}</a>
                  <p>Part Number: {partNumber}</p>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={2}>
              <strong>Qty: </strong>
              <label>{quantity}</label>
              <label>
                &nbsp;&nbsp; {price}/{unitOfMeasure}
              </label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={2}>
              <strong>Price: </strong>
              <label>{totalProductPrice}</label>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <hr />
          </Grid>
          <Grid item xs={12} sm={12} md={7.5} lg={7.5}>
            <a onClick={handleClose} className="continueShopping">
              Continue Shopping
            </a>
          </Grid>
          <Grid item xs={12} sm={12} md={2} lg={2}>
            <RoundButton
              name={viewCartText}
              classname="grey-button"
              onClick={() => viewCartUrl()}
            />
          </Grid>
          <Grid item xs={0} sm={0} md={0.5} lg={0.5} />
          <Grid item xs={12} sm={12} md={2} lg={2}>
            <RoundButton
              name="Check Out"
              classname="yellow-button"
              onClick={() => checkoutUrl()}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
